export default __webpack_public_path__ + "static/media/title_02.e7975118.png";